<template>
  <b-button 
    :id="id"
    variant="transparent-lightBlue" 
    class="btn-square" 
    :title="title"
    v-b-tooltip.manual
    @click="(e) => { $emit('click', e) }"
    @mouseover="mouseover"
    @mouseleave="mouseleave"
  >
    <slot></slot>
  </b-button>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    title: {
      default: false,
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
    }),
    id() {
      return `texteditor-tool-${this.title.replaceAll(' ', '')}`;
    },
  },
  methods: {
    mouseover() {
      if (this.id) this.$root.$emit('bv::show::tooltip', this.id)
    },
    mouseleave() {
      if (this.id) this.$root.$emit('bv::hide::tooltip', this.id)
    }
  },
}
</script>
